import React, { Component } from 'react';
import { Box, CircularProgress, Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { push } from 'react-router-redux'

import Header from '../components/Header';
import { Body, HeadlessBody } from '../components/Body';
import Settings from '../components/Settings'
import FormActions from '../components/FormActions'
import ViewPreview from './ViewPreview'
import QuizViewPreview from './QuizViewPreview'
import { FORM_LIST_VIEW, FORM_SETTINGS_VIEW, QUIZ_SUBMISSION_VIEW, cancel } from '../actions/main'
import { editForm } from '../actions/formList'
import {tabButtons} from '../defaults/templates'
import { selectTab, setSettings } from '../actions/settings'


import '../components/App.css';

import { getFormListByUserId } from '../actions/formList'
import { getQuizResultsById } from '../actions/answers'

const w = 940
const h = 800

const PopupContainerStyles = makeStyles({
  root:{
      backgroundColor: '#ffffff',
      position: 'absolute',
      left: 0,
      top: 0,
      right:0,
      bottom:0
  },
  loaderBox:{
    color: "#f5b01b",
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    margin: "auto"
  }
});

const PopupList = ({cancelAction, main}) => {
  const classes = PopupContainerStyles();
  switch (main.view) {
    case FORM_LIST_VIEW:
      return (
        <Box className={classes.root} width={w} height={h} p={0} m="auto">
          <Header content="Forms" view={FORM_LIST_VIEW} cancelAction={cancelAction} ></Header>
          <Body>
            <FormActions main={main} />
          </Body>
        </Box>
      );
    default:
      return (<Loader />)
  } 
}

const PopupSettings = ({cancelAction, main, tab}) => {
  const classes = PopupContainerStyles();
  switch (main.view) {
      case FORM_SETTINGS_VIEW:
      return (
        <Box className={classes.root} width={w} height={h} p={0} m="auto">
          <Header content="Form Builder" view={FORM_SETTINGS_VIEW} cancelAction={cancelAction}></Header>
          <Body>
            <Settings tab={tab}></Settings>
          </Body>
        </Box>
      );
    default:
      return (<Loader />)
  }    
}


const PopupSubmission = ({ cancelAction, main, quizId}) => {
  const classes = PopupContainerStyles();
  switch (main.view) {
      case QUIZ_SUBMISSION_VIEW:
      //default:
      return (
        <Box className={classes.root} p={0} m="auto">
          {/*<Header content="Submission Data" view={QUIZ_SUBMISSION_VIEW} cancelAction={cancelAction}></Header>*/}
            <HeadlessBody>
                <QuizViewPreview quizId={quizId}></QuizViewPreview>
            {/*<Settings tab={tab}></Settings>*/}
            </HeadlessBody>
        </Box>
      );
    default:
        return (<HeadlessLoader />)
  }    
}



const Loader = () => {
  const classes = PopupContainerStyles();
  return (
    <Box className={classes.root} width={w} height={h} p={0} m="auto">
      <Header content="Loading..." view={FORM_LIST_VIEW} ></Header>
      <Body >
        <CircularProgress className={classes.loaderBox} size={70}></CircularProgress>
      </Body>      
    </Box>      
  );
}
const HeadlessLoader = () => {
    const classes = PopupContainerStyles();
    return (
        <Box className={classes.root} width={w} height={h} p={0} m="auto">
            <HeadlessBody >
                <CircularProgress className={classes.loaderBox} size={70}></CircularProgress>
            </HeadlessBody>
        </Box>
    );
}
class PopupContainer extends Component{

  componentDidMount(){
    if(this.props.getFormListByUserId){
      this.props.getFormListByUserId();
    }        
  }

  render(){
    return(
      <Box>
        {this.props.children}
      </Box>      
    )
  }
}

const _PopupList = ({cancel, main, getFormListByUserId, ownProps}) => {
  window["r_ownProps"] = ownProps;
  window["r_browserHistory"] = browserHistory;
  window["r_push"] = push;
  
  return(
    <div className="App-container">
      <Container>
        <PopupContainer getFormListByUserId={getFormListByUserId}>
          <PopupList cancelAction={cancel} main={main} />
        </PopupContainer>
      </Container>
    </div>
  )
}

const _PopupSettings = ({cancel, main, settings, ownProps, id, tab, editForm, fromEditor}) => {
  //console.log("ownProps: ", ownProps)
  //console.log("Form ID: ", id)
  //console.log("tab: ", tab)
  window["r_browserHistory"] = browserHistory;
  let goTab = tabButtons[0].name;
  if(tab){
    goTab = tab    
  }
    // if we have a form id to start editing, start editing it now
  if(!main.asyncRequest && id > 0 && (!settings.form || settings.form.FormId != id)){
      editForm(id, null, fromEditor);
  }
  return(
    <div className="App-container">
      <Container>
        <PopupContainer>
                  <PopupSettings cancelAction={cancel} main={main} tab={goTab} />
        </PopupContainer>
      </Container>
    </div>
  )
}


class _PopupContainerQuiz extends Component {

    componentDidMount() {

        if (this.props.getQuizResultsById && this.props.quizId) {
            this.props.getQuizResultsById(this.props.quizId);
        }
    }
    
    render() {
        let main = this.props.main;
        let cancel = this.props.cancel;
        let quizId = this.props.quizId;
        let getQuizResultsById = this.props.getQuizResultsById;
        return (
            <div className="App-container">
                <Container>
                    <PopupContainer>
                        <PopupSubmission cancelAction={cancel} main={main} quizId={this.props.quizId} getQuizResultsById={getQuizResultsById}></PopupSubmission>
                    </PopupContainer>
                </Container>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) =>({
  main: state.main,
  settings: state.settings,
  ownProps: ownProps,
  id: ownProps.params.id,
  quizId: ownProps.params.quizid,
  tab: ownProps.params.tab,
  fromEditor: ownProps.fromEditor,

})

const mapDispatchToProps = dispatch => ({
  getFormListByUserId: userId => dispatch(getFormListByUserId(userId)),
  cancel: (currentView) => dispatch(cancel(currentView)),
  editForm: (id, isPreview, fromEditor) => dispatch(editForm(id, isPreview, fromEditor)),
  selectTab: id => dispatch(selectTab(id)),
  setSettings: (form, config) => dispatch(setSettings(form, config)),
  getQuizResultsById: (id) => dispatch(getQuizResultsById(id))
})

export const PopupContainerList = connect(mapStateToProps, mapDispatchToProps)(_PopupList)
export const PopupContainerSettings = connect(mapStateToProps, mapDispatchToProps)(_PopupSettings)
export const PopupContainerQuiz = connect(mapStateToProps, mapDispatchToProps)(_PopupContainerQuiz)

 